import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowInTopLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowInTopLeft"><Path d="M6.5 13.5V21.5H21.5V6.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10 10L3.5 3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 3.5V10.5L3.5 10.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowInTopLeft;
